import { Contact } from "./data";

export const CardsData = [
  {
    img: "/oldSite/altura.jpg",
    title: "Limpieza de Vidrios en Altura",
    description:
      "Recomendado para edificios. * sujeto a supervisión de anclajes. ABONOS MENSUALES, BIMESTRALES Y TRIMESTRALES. Profesionales con seguro de altura ilimitado en vigencia, clausulas de no repetición. Programa de seguridad e higiene.",
    link: `${Contact.whatsApp}`,
  },
  {
    img: "/mantenimiento-y-restauraciones-edilicias.png",
    title: "Mantenimiento y restauraciones Edilicias",
    description: "HIDROLAVADOS, VIDRIOS, PINTURA, REPARACIONES",
    link: `${Contact.whatsApp}`,
  },
  {
    img: "/oldSite/finales.jpg",
    title: "Finales de Obra",
    description:
      "Servicio especializado en limpireza de finales de obra. Vasta experiencia y calidad de servicio le aseguran una terminación adecuada en tiempo y forma. Recomendado para Deptos, Casas grandes (base desde 100m2). Profesionales con seguro de altura ilimitado en vigencia. Claúsulas de no repetición.",
    link: `${Contact.whatsApp}`,
  },
  {
    img: "/casaThames.webp",
    title: 'Distribuidor Oficial "CASA THAMES"',
    description:
      "CONSULTE VENTA MAYORISTA DE PRODUCTOS, EQUIPOS E INSUMOS NACIONALES E IMPORTADOR: SOMOS DISTRIBUIDORES OFICIALES DE CASA THAMES",
    link: `${Contact.whatsApp}`,
  },
  {
    img: "/limpiezaDeOficinas.webp",
    title: "Limpieza en Oficinas y Consorcios",
    description:
      "Profesionales con experiencia con y sin insumos, con seguros de accidente y claúsulas de no repetición a favor del cliente. • ABONOS FIJOS ACTUALIZADOS CADA 3 MESES! • ATENCION ESPECIALIZADA PARA CONSORCIOS • OPCIONAL INSUMOS • FINALES DE OBRAS EN LOCALES, CASAS, DEPTOS.",
    link: `${Contact.whatsApp}`,
  },
  {
    img: "/asociate.png",
    title: "Asociate a VIDRIOS LIMPIOS",
    description:
      "SOS PROFESIONAL DE LIMPIEZA DE VIDRIOS INDEPENDIENTE? BUSCAS INCREMENTAR TU CARTERA DE TRABAJO? NECESITAS NUEVOS CLIENTES EN TU ZONA/BARRIO O REGION? PLANIFICAS ARMAR TUS PROPIOS EQUIPOS? ASESORAMIENTO POR EMPRESA LIDER DEL RUBRO! BENEFICIOS EN VENTA DE EQUIPOS E INSUMOS!",
    link: `${Contact.whatsApp}`,
  },
];

export const MarksData = [
  { title: "UTHGRA", img: "/oldSite/01.jpg" },
  { title: "GUTEN BIER", img: "/oldSite/02.jpg" },
  { title: "AMIGOS DEL BELLAS ARTES", img: "/oldSite/03.jpg" },
  { title: "EILIM", img: "/oldSite/04.jpg" },
  { title: "CAFFE DEL DOGE", img: "/oldSite/05.jpg" },
  { title: "BREMEN", img: "/oldSite/06.jpg" },
  { title: "ACCESS", img: "/oldSite/07.jpg" },
  { title: "EMS SERVICES", img: "/oldSite/08.jpg" },
  { title: "EMBAJADA DE LA REPUBLICA DE SUDAFRICA", img: "/oldSite/09.jpg" },
  { title: "IDEA", img: "/oldSite/10.jpg" },
  { title: "MADERO WALK", img: "/oldSite/11.jpg" },
  { title: "CENTRY", img: "/oldSite/12.jpg" },
  { title: "DAPONTE", img: "/oldSite/13.jpg" },
  { title: "RADIO VICTORIA", img: "/oldSite/14.jpg" },
  { title: "Z", img: "/oldSite/15.jpg" },
  { title: "SPORT CLUB", img: "/oldSite/16.jpg" },
  { title: "IGLESIA NUEVA APOSTOLICA", img: "/oldSite/17.jpg" },
  { title: "AMOBA", img: "/oldSite/18.jpg" },
  { title: "UNECONSULTING", img: "/oldSite/19.jpg" },
  { title: "COTO", img: "/oldSite/20.jpg" },
  { title: "SANTA CATALINA", img: "/oldSite/21.jpg" },
  { title: "TRAVEL RENT A CAR", img: "/oldSite/22.jpg" },
  { title: "BMW", img: "/marks/bmw.jpg" },
  { title: "DARC", img: "/marks/darc.png" },
  { title: "FADESA", img: "/marks/fadesa.jpg" },
  { title: "GRAND KING", img: "/marks/grandking.jpg" },
  { title: "HORMIGA NEGRA", img: "/marks/hormigaNegra.jpg" },
  { title: "LONGO HUE", img: "/marks/lonco-hue.png" },
  { title: "PORTAL MAESTRO", img: "/marks/portalMaestro.png" },
  { title: "REMAX", img: "/marks/remax.jpg" },
  { title: "NOGOYA", img: "/marks/nogoya.jpg" },
];

export const MenuData = [
  {
    title: "MANTENIMIENTO Y RESTAURACIONES EDILICIAS",
    link: "/mantenimiento-y-restauraciones-edilicias",
    // icon: "/icons/nuevoServicioIcon.png",
  },
  {
    title: "SERVICIOS DE ALTURA",
    link: "/servicios-de-altura",
  },
  {
    title: "DISTRIBUIDOR OFICIAL",
    link: "/distribuidor-thames",
    img: "casaThames.webp",
  },
  { title: "CONTACTO", link: "/" },
];

export const ServicesData = [
  { name: "Limpieza de Vidrios" },
  { name: "Mantenimiento y Restauraciones Edilicias" },
  { name: "Limpieza de Oficinas" },
  { name: "Finales de Obra" },
  { name: "Limpieza en Altura" },
  { name: "Limpieza de Consorcios" },
  { name: "Distribuidor Oficial 'CASA THAMES'" },
];

export const SpecialServicesData = [
  { name: "Pintura" },
  { name: "Sellados" },
  { name: "Impermeabilizaciones" },
  { name: "Hidrolavados" },
  { name: "Instalacion equipos AA" },
  { name: "Vidrios" },
  { name: "Albañilería" },
];

export const ClientsData = [
  { name: "TRAVEL RENT A CAR: www.travelrentacar.com.ar" },
  { name: "CENTRY S.A.: www.centry.com.ar" },
  { name: "EMBAJADA DE LA REPUBLICA DE SUDAFRICA" },
  { name: "GRUPO D’Arc Citroen y Peugeot" },
  { name: "BREMEN MOTORS" },
  { name: "NISSAN TAIKKI" },
  { name: "HOTEL GRAND KING" },
  { name: "LONCO HUE MERCEDES BENZ" },
  { name: "CLINICA NOGOYA" },
  { name: "CERVECERIA HORMIGA NEGRA SUC MORENO" },
  { name: "MUCHO +QUE PADEL BENAVIDEZ" },
  { name: "ACCESS MEDICAL S.A." },
  { name: "PORTAL MAESTRO LOMAS DE ZAMORA" },
  { name: "INVAGRO SRL" },
  { name: "REMAX SUC INCAS CABA" },
  { name: "ESCUELA JACARANDA" },
  { name: "IVECO TORTUGUITAS" },
  { name: "GRUPO IDEA" },
  { name: "MAYNAR VW" },
  { name: "RADIO VICTORIA S.A." },
  {
    name: `BARRIOS PRIVADOS: LOS TALAS (CANING), ISLA DEL SOL (TIGRE),
  PUERTOS DEL LAGO ( ESCOBAR), MIRALAGOS, SANTA BARBARA, EL MOLINO,
  ENTRE OTROS DE ZONA NORTE, SUR Y OESTE.`,
  },
  { name: "CONSORCIOS EN CABA Y GRAN BS AS." },
  { name: "CIUDAD DE CORDOBA Y ALREDEDORES." },
];
export const OperationsData = [
  {
    name: "Av. San Juan 1896 - CABA",
    imgs: {
      before: [
        {
          title: "Fachada 1",
          img: "/buildingMaintenanceAndRestorations/before/fachada1.png",
        },
      ],
      after: [
        {
          title: "Fachada 1",
          img: "/buildingMaintenanceAndRestorations/after/restauracion-fachada1.jpg",
        },
        {
          title: "Fachada 2",
          img: "/buildingMaintenanceAndRestorations/after/restauracion-fachada2.jpeg",
        },
        {
          title: "Fachada 3",
          img: "/buildingMaintenanceAndRestorations/after/restauracion-fachada3.jpg",
        },
        {
          title: "Fachada 4",
          img: "/buildingMaintenanceAndRestorations/after/restauracion-fachada4.jpg",
        },
      ],
    },
  },
];
